import { Component, OnDestroy } from "@angular/core";
import { FormControl, FormGroup, Validators } from "@angular/forms";
import { Subscription } from "rxjs";
import { Media } from "../../../../../../features/media/domain/models/media";
import { CustomFormValidators } from "../../../../../../shared/validators/custom-form-validators";
import { PublicationTemplateForm } from "../../../components/publication-template-form/publication-template-form";
import {
  getField,
  InstagramCarouselFields,
} from "../../../data/entities/publication-template-fields.entity";
import {
  InstagramCarouselSizeRules,
  TextRules,
} from "../../../data/entities/publication-template-rules.entity";
import { PublicationTemplateType } from "../../../data/entities/publication-templates.entity";
import { InstagramCarousel } from "../../../domain/models/instagram-carousel";

export interface InstagramCarouselForm {
  media: FormControl<Media[] | null>;
  text: FormControl<string | null>;
}

@Component({
  selector: "app-instagram-carousel-form",
  templateUrl: "./instagram-carousel-form.component.html",
  styleUrls: [
    "./instagram-carousel-form.component.scss",
    "../../../components/publication-template-form/publication-template-form.scss",
  ],
})
export class InstagramCarouselFormComponent
  extends PublicationTemplateForm<InstagramCarouselForm>
  implements OnDestroy
{
  public fields!: InstagramCarouselFields;
  private readonly subscription = new Subscription();
  protected maxMediaSize = 20;
  protected minMediaSize = 1;

  constructor() {
    super(PublicationTemplateType.InstagramCarousel);
  }

  public ngOnDestroy(): void {
    this.subscription.unsubscribe();
  }

  public createForm(): void {
    const mediaRules = getField("mediaIds", this.fields)
      .rules as InstagramCarouselSizeRules;
    const textRules = getField("text", this.fields).rules as TextRules;
    this.minMediaSize = mediaRules.minMediaSize.constraint;
    this.maxMediaSize = mediaRules.maxMediaSize.constraint;

    this.form = new FormGroup<InstagramCarouselForm>({
      media: new FormControl<Media[]>(
        [],
        [
          CustomFormValidators.minSizeValidator(this.minMediaSize),
          CustomFormValidators.maxSizeValidator(this.maxMediaSize),
        ],
      ),
      text: new FormControl<string | null>(null, [
        Validators.maxLength(textRules.maxTextLength.constraint),
      ]),
    });
  }

  public setFormValues(carousel: InstagramCarousel): void {
    this.form.controls.media.patchValue(carousel.media);
    this.form.controls.text = new FormControl<string | null>(carousel.text);
  }

  protected onActionDeleteMedia(index: number): void {
    if (!this.form.controls.media.value?.length) {
      return;
    }

    const newValue = [...this.form.controls.media.value];
    newValue.splice(index, 1);
    this.form.controls.media.patchValue(newValue);
  }
}
